import './style.css';

const resources = [
  {
    name: 'MDN Web Docs',
    category: 'Documentation',
    link: 'https://developer.mozilla.org/',
    description:
      'The definitive source for web documentation, tutorials, and references.',
  },
  {
    name: 'Vite',
    category: 'Tooling',
    link: 'https://vitejs.dev/',
    description:
      'Next generation front-end tooling that is fast and incredibly easy to use.',
  },
  {
    name: 'ESLint',
    category: 'Code Quality',
    link: 'https://eslint.org/',
    description:
      'Find, fix, and enforce consistency problems in your JavaScript code.',
  },
  {
    name: 'Prettier',
    category: 'Formatting',
    link: 'https://prettier.io/',
    description:
      'An opinionated code formatter that supports many languages and integrates closely with editors.',
  },
  {
    name: 'TypeScript',
    category: 'Language',
    link: 'https://www.typescriptlang.org/',
    description:
      'A strongly typed programming language that builds on JavaScript.',
  },
  {
    name: 'Tailwind CSS',
    category: 'Styling',
    link: 'https://tailwindcss.com/',
    description:
      'A utility-first CSS framework packed with classes that can be composed to build any design.',
  },
];

const renderResources = (data) => {
  const container = document.getElementById('resourcesList');
  if (!container) return; // Prevent rendering if container is missing

  container.innerHTML = data
    .map(
      (resource) => `
    <a href="${resource.link}" target="_blank" rel="noopener noreferrer" class="resource-card">
      <div class="card-category">${resource.category}</div>
      <h2 class="card-name">${resource.name}</h2>
      <p class="card-description">${resource.description}</p>
    </a>
  `
    )
    .join('');
};

// Initial Render
renderResources(resources);

// Setup Search Filter Functionality
const searchInput = document.getElementById('searchInput');
if (searchInput) {
  searchInput.addEventListener('input', (event) => {
    const searchTerm = event.target.value.toLowerCase();

    // Filter resources dynamically
    const filtered = resources.filter((res) => {
      return (
        res.name.toLowerCase().includes(searchTerm) ||
        res.category.toLowerCase().includes(searchTerm) ||
        res.description.toLowerCase().includes(searchTerm)
      );
    });

    renderResources(filtered);
  });
}
